import React from 'react';
import ArtGallery from '../components/art/ArtGallery';
import ContactForm from '../components/contact/ContactForm';
import SuccessModal from '../components/contact/SuccessModal';
import { useContact } from '../hooks/useContact';
import SEO from '../components/SEO';

const Art = ({ siteData }) => {
    const {
        isContactFormOpen,
        isSuccessModalOpen,
        contactData,
        openContactForm,
        closeContactForm,
        handleContactSuccess,
        closeSuccessModal,
    } = useContact();

    return (
        <>
            <SEO
                title="Art Gallery | Savana Ashlea"
                description="Discover meaningful artwork that captures emotion and beauty. Browse my collection of original art pieces and creative expressions."
                url="https://savanashlea.com/art"
                image="/art-og.jpg"
            />
            <div className="pt-16 min-h-screen bg-white">
                <ArtGallery artData={siteData?.art} onContactClick={openContactForm} />

                {isContactFormOpen && (
                    <ContactForm
                        inquiryType={contactData.inquiryType}
                        prefilledData={contactData.prefilledData}
                        onClose={closeContactForm}
                        onSuccess={handleContactSuccess}
                    />
                )}

                {isSuccessModalOpen && (
                    <SuccessModal onClose={closeSuccessModal} />
                )}
            </div>
        </>
    );
};

export default Art;